<template>
  <div class="backlog">
    <van-tabs v-model="active" sticky animated swipe-threshold="1">
      <van-tab v-for="(el, index) in Treelist" :key="index">
        <template #title>
          <span @click="activeClick(el)" class="engineeringSpan">{{
            el.name
          }}</span>
        </template>
        <van-list
          v-model="loading"
          :finished="finished"
          style="margin-top: 10px"
          finished-text="没有更多了"
          @load="getData"
          :immediate-check="false"
          v-if="active == 0"
        >
          <div v-if="list.length > 0">
            <div>
              <div
                class="menuStyle"
                v-for="(item, index) in list"
                :key="index"
                @click="go(item)"
              >
                <div class="flexcolumn">
                  <div
                    class="flexLR"
                    style="width: 100%; justify-content: space-between"
                  >
                    <div class="flexLR" style="width: 30%">
                      <img
                        :src="$store.state.baseUrl + item.user13"
                        width="30"
                        style="border-radius: 50%"
                        alt=""
                      />
                      <div style="font-size: 14px">{{ item.user04 }}</div>
                    </div>
                    <div style="color: #bdbdbd">{{ item.famp10 }}</div>
                    <!-- <div class="bd">流程表单</div> -->
                  </div>
                  <div
                    class="flexLR"
                    style="width: 80%; justify-content: start"
                  >
                    <div
                      style="color: red; width: 28%"
                      v-show="item.famp13 == 1"
                      class="flex"
                    >
                      <van-icon name="clock-o" size="16" />催办
                    </div>
                    <div
                      style="
                        font-size: 14px;
                        font-weight: bold;
                        margin-left: 20px;
                        width: 100%;
                      "
                    >
                      {{ item.fmap03 }}
                    </div>
                  </div>
                  <div
                    class="flexLR"
                    style="border-top: 1px solid #f1f1f1; padding-top: 10px"
                  >
                    <div class="flexLR">
                      <div>
                        <p>审核:</p>
                        {{ item.auditUsers }}
                      </div>
                      <div>{{ item.parent ? item.parent.parentName : "" }}</div>
                    </div>
                  </div>
                </div>
                <span>{{
                  item.famp11 == 1
                    ? "进行中"
                    : scope.row.famp11 == 2
                    ? "已通过"
                    : scope.row.famp11 == 3
                    ? "未通过"
                    : "已撤回"
                }}</span>
              </div>
            </div>
          </div>
          <div
            v-else
            style="color: #0a9efc; margin-top: 100px; text-align: center"
          >
            <img src="../../../assets/mobileImg/wu.png" width="60" alt="" />
            <div>暂无数据</div>
          </div>
        </van-list>
        <van-list
          v-model="loading"
          :finished="finished"
          style="margin-top: 10px"
          finished-text="没有更多了"
          @load="getData"
          :immediate-check="false"
          v-else-if="active == 1"
        >
          <div v-if="list.length > 0">
            <div>
              <div
                class="menuStyle"
                v-for="(item, index) in list"
                :key="index"
                @click="
                  $router.push({
                    path: '/home/menu/schedule',
                    query: {
                      obj: encodeURIComponent(
                        JSON.stringify({
                          id: item.pldt03,
                          parentId: item.pldt01,
                          name: item.pldt04,
                          pjpl11: item.pjpl11,
                        })
                      ),
                    },
                  })
                "
              >
                <div class="flexcolumn">
                  <div class="flexLR" style="width: 100%">
                    <div
                      class="flexLR"
                      style="
                        width: 100%;
                        overflow-y: hidden;
                        justify-content: space-between;
                      "
                    >
                      <img
                        :src="$store.state.baseUrl + item.pldt12List[0].user13"
                        width="30"
                        style="border-radius: 50%"
                        alt=""
                      />
                      <div style="font-size: 14px; white-space: pre">
                        {{ item.pldt12Name }}
                      </div>
                    </div>
                  </div>
                  <div class="flexLR">
                    <div style="color: #bdbdbd">{{ item.pldt20 }}</div>
                    <div class="bd">进度上报</div>
                  </div>
                  <div
                    class="flexLR"
                    style="width: 100%; justify-content: start; padding: 20px"
                  >
                    <div
                      style="color: red; width: 20%"
                      v-if="
                        isShow(item) <= 2 && item.pldt05 != 100 ? true : false
                      "
                      class="flex"
                    >
                      <van-icon name="warning-o" size="16" />
                      预警
                    </div>
                    <div style="color: #ff8100; width: 20%" v-else class="flex">
                      <van-icon name="clock-o" size="16" />
                      延期
                    </div>
                    <div
                      style="
                        font-size: 14px;
                        font-weight: bold;
                        margin-left: 20px;
                      "
                    >
                      {{ item.pldt04 }}
                    </div>
                  </div>
                  <div
                    class="flexLR"
                    style="border-top: 1px solid #f1f1f1; padding-top: 10px"
                  >
                    <div>
                      <p>计划结束时间:</p>
                      {{ item.pldt07 }}
                    </div>
                  </div>
                </div>
                <span>未完成</span>
              </div>
            </div>
          </div>
          <div
            v-else
            style="color: #0a9efc; margin-top: 100px; text-align: center"
          >
            <img src="../../../assets/mobileImg/wu.png" width="60" alt="" />
            <div>暂无数据</div>
          </div>
        </van-list>
        <van-list
          v-model="loading"
          :finished="finished"
          style="margin-top: 10px"
          finished-text="没有更多了"
          @load="getData"
          :immediate-check="false"
          v-else-if="active == 2"
        >
          <div v-if="list.length > 0">
            <div>
              <div
                class="menuStyle"
                v-for="(item, index) in list"
                :key="index"
                @click="
                  item.state == '未启动延误' || item.state == '待启动'
                    ? true
                    : $router.push({
                        path: '/home/menu/gdInfo',
                        query: { id: item.famp01 },
                      })
                "
              >
                <div class="flexcolumn">
                  <div class="flexLR" style="width: 100%">
                    <div class="flexLR" style="width: 30%">
                      <img
                        :src="$store.state.baseUrl + item.user13"
                        width="30"
                        style="border-radius: 50%"
                        alt=""
                      />
                      <div style="font-size: 14px">{{ item.user04 }}</div>
                    </div>
                    <div style="color: #bdbdbd">{{ item.famp10 }}</div>
                    <div class="bd">工单任务</div>
                  </div>
                  <div class="flexLR" style="width: 100%">
                    <div
                      style="color: red; width: 28%"
                      v-show="item.famp13 == 1"
                      class="flex"
                    >
                      <van-icon name="clock-o" size="16" />催办
                    </div>
                    <div
                      style="
                        font-size: 14px;
                        font-weight: bold;
                        margin-left: 20px;
                      "
                    >
                      {{ item.wkod02 }}
                    </div>
                    <div
                      style="width: 20px"
                      @click="startBtn(item)"
                      v-if="
                        item.state == '未启动延误' || item.state == '待启动'
                          ? true
                          : false
                      "
                    >
                      <van-icon name="play-circle-o" size="20" />
                    </div>
                  </div>
                  <div
                    class="flexLR"
                    style="border-top: 1px solid #f1f1f1; padding-top: 10px"
                  >
                    <div>
                      <p>审核:</p>
                      {{ item.wkod08Name }}
                    </div>
                    <div>
                      <p>执行:</p>
                      {{ item.wkod19Name }}
                    </div>
                  </div>
                </div>
                <span
                  :style="{
                    backgroundColor:
                      item.state == '未启动延误' || item.state == '待启动'
                        ? 'red'
                        : '#0095ff',
                  }"
                  >{{ item.state }}</span
                >
              </div>
            </div>
          </div>
          <div
            v-else
            style="color: #0a9efc; margin-top: 100px; text-align: center"
          >
            <img src="../../../assets/mobileImg/wu.png" width="60" alt="" />
            <div>暂无数据</div>
          </div>
        </van-list>
        <!-- <van-list v-model="loading" :finished="finished" style="margin-top: 10px" finished-text="没有更多了" @load="getData"
          :immediate-check="false" v-else>
          <div v-if="list.length > 0">
            <div>
              <div class="menuStyle" v-for="(item, index) in list" :style="item.fmtp09===2?'background-color:#ffe98d':''" :key="index" @click="
                  $router.push({
                    path: '/home/menu/SecurityPatrol',
                    query: { type: item.famp01 },
                  })
              ">
                <div class="flexcolumn">
                  <div class="flexLR" style="width: 100%;justify-content: inherit;">
                    <div class="flexLR" style="width: 20%">
                      <img :src="$store.state.baseUrl + item.user13" width="30" style="border-radius: 50%" alt="" />
                      <div style="font-size: 14px">{{ item.user04 }}</div>
                    </div>
                    <div style="color: #bdbdbd">{{ item.famp10 }}</div>
                    <div class="bd">安全巡查</div>
                  </div>
                  <div class="flexLR" style="width:100%;justify-content: inherit;">
                    <div style="color: red; width: 28%" v-show="item.famp13 == 1" class="flex">
                      <van-icon name="clock-o" size="16" />催办
                    </div>
                    <div style="
                        font-size: 14px;
                        font-weight: bold;
                        margin-left: 20px;
                      ">
                      {{ item.fmap03 }}
                    </div>
                    <div style="width:20px" @click="startBtn(item)"
                      v-if="item.state == '未启动延误' || item.state == '待启动' ? true : false">
                      <van-icon name="play-circle-o" size="20" />
                    </div>
                  </div>
                  <div class="flexLR" style="border-top: 1px solid #f1f1f1; padding-top: 10px">
                    <div>
                      <p>审核:</p>
                      {{ item.auditUsers }}
                    </div>
                    <div>
                      <p>抄送:</p>
                      {{ item.CCUsers }}
                    </div>
                  </div>
                </div>
                <span :style="{
                  backgroundColor:
                    famp11(item.famp11) == '已驳回' || famp11(item.famp11) == '已撤回'
                      ? 'red'
                      : '#0095ff',
                }">{{ famp11(item.famp11) }}</span>
              </div>
            </div>
          </div>
          <div v-else style="color: #0a9efc; margin-top: 100px; text-align: center">
            <img src="../../../assets/mobileImg/wu.png" width="60" alt="" />
            <div>暂无数据</div>
          </div>
        </van-list> -->
      </van-tab>
    </van-tabs>
    <van-overlay z-index="999999" :show="show" @click="show = false">
      <van-loading
        style="top: 50%"
        vertical
        type="spinner"
        color="#1989fa"
      ></van-loading
      >>
    </van-overlay>
  </div>
</template>

<script>
import {
  GetFormTask,
  GetPlanTask,
  GetWorkOrderTask,
  FindFormApplyDetail,
  UpdateWorkOrderTime,
  GetFunctionTemplate,
} from "@/api/index";
export default {
  name: "dd_backlog",
  components: {},
  data() {
    return {
      list: [],
      loading: false,
      show: false,
      finished: false,
      active: 0,
      pageSize: 0,
      Treelist: [
        { name: "流程表单", id: 0 },
        { name: "进度上报", id: 1 },
        { name: "工单任务", id: 2 },
        // { name: "安全巡查", id: 3 },
      ],
    };
  },
  computed: {
    isShow: function () {
      return (i) => {
        var newTime = new Date();
        var dTime = new Date(i.pldt07N);
        return newTime - dTime < 0
          ? parseInt(Math.abs(newTime - dTime) / 1000 / 60 / 60 / 24)
          : 0;
      };
    },
    famp11() {
      return function (data) {
        switch (data) {
          case 1:
            return "审核中";
          case 2:
            return "已通过";
          case 3:
            return "已驳回";
          case 4:
            return "已撤回";
          default:
            return "未知状态";
        }
      };
    },
  },
  watch: {},
  methods: {
    async startBtn(item) {
      UpdateWorkOrderTime({ wid: item.wkod01, type: 1 }).then((res) => {
        if (res.Code == 1) {
          this.$Toast("启动成功");
          this.getData();
        }
      });
    },
    async FindFormApplyDetail(item) {
      this.show = true;
      let res = await FindFormApplyDetail({
        params: {
          id: item.fmap01,
        },
      });
      console.log(res.Data);
      this.show = false;
      this.$router.push({ name: "bdInfo", params: { res: res.Data } });
      // this.$router.push({ name: "MenuTemplate", params: { res: res.Data } });
    },
    go(data) {
      console.log(data, "-----===");
      this.$router.push({
        name: "MenuTemplate",
        query: {
          type: data.parent.fctm01,
          name: data.parent.fctm02,
        },
      });
    },
    activeClick(item) {
      this.active = item.id;
      this.list = [];
      this.getData();
    },
    async getData() {
      this.loading = true;
      // this.show = true;
      let res;
      if (this.active == 0) {
        res = await GetFormTask({
          params: {
            xid: this.$store.state.pid,
            uid: this.$store.state.uid,
          },
        });
      } else if (this.active == 1) {
        res = await GetPlanTask({
          params: {
            xid: this.$store.state.pid,
            uid: this.$store.state.uid,
            type: 1,
          },
        });
      } else if (this.active == 2) {
        res = await GetWorkOrderTask({
          params: {
            xid: this.$store.state.pid,
            uid: this.$store.state.uid,
            type: 2,
          },
        });
      } else {
        res = await GetFormTask({
          params: {
            xid: this.$store.state.pid,
            uid: this.$store.state.uid,
            type: 2,
          },
        });
      }

      GetFunctionTemplate({ params: { xid: localStorage.xid } }).then((r) => {
        this.list = res.Data;
        this.list = res.Data.filter((el) => {
          let item = this.find(
            this.getTreeDate(
              r.Data.projectfunctiontemplates,
              "fctm01",
              "fctm03"
            ),
            el.famp14
          );
          if (item) {
            el.parent = item;
            return true;
          } else {
            return false;
          }
        });
        this.finished = true;
        this.loading = false;
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        item.id = `Tree${item[idName]}`;
        item.authName = item.fctm02;
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        item["path"] = "MenuTemplate";
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          parent.parentName
            ? (item.parentName = "-" + parent.parentName + item.authName)
            : (item.parentName = parent.authName + "-" + item.authName);
          (parent.children || (parent.children = [])).push(item);
        } else {
          (item["icon"] = "el-icon-star-on"), result.push(item);
        }
      });
      return result;
    },
    find(list, id) {
      let _this = this;
      let result;
      for (let index = 0; index < list.length; index++) {
        const el = list[index];
        if (el.fctm01 == id) {
          result = el;
          return result;
        } else if (el.children && el.children.length) {
          result = _this.find(el.children, id);
          if (result) {
            return result;
          }
        }
      }
      return result;
    },

    updateData() {
      this.$emit("updateLoading");
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.backlog {
  .flexLR {
    img {
      width: 60px;
      height: 60px;
    }
  }

  .menuStyle {
    position: relative;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 40px;
    border-radius: 20px;
    padding: 40px;
    padding-top: 50px;
    min-height: 220px;

    span {
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      width: 150px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: white;
      border-radius: 0 20px 0 20px;
      background-color: red;
    }

    .flexcolumn {
      min-height: 220px;
      align-items: flex-start;
      justify-content: space-between;

      .flexLR {
        width: 100%;

        .bd {
          border: 2px solid rgb(0, 174, 255);
          color: rgb(0, 174, 255);
          padding: 0px 10px;
          border-radius: 30px;
        }

        p {
          color: #a9a9a9;
          display: inline-block;
        }
      }
    }
  }

  /deep/ .van-tabs__line {
    background-color: rgb(255, 255, 255);
  }

  /deep/ .van-tabs__nav {
    background-color: rgba(255, 255, 255, 0);
  }

  // /deep/ .van-tab{
  //   background-color: #2e6be6;
  // }
  // /deep/ .van-tabs__nav{
  //   margin-top:-6px;
  // }
  .engineeringSpan {
    color: white;
  }

  /deep/ .van-tab__text {
    padding: 0 10px;
  }

  /deep/ .van-tab--active .van-tab__text .engineeringSpan {
    position: relative;
    z-index: 1;
    min-width: 62px;
    text-align: center;
    display: block;
    color: rgb(0, 119, 255);

    &::after {
      content: "";
      position: absolute;
      left: -5px;
      z-index: -1;
      top: 0;
      background-color: rgb(255, 255, 255);
      width: 100%;
      padding: 0 5px;
      border-radius: 10px;
      height: 100%;
    }
  }

  /deep/ .van-tabs__content {
    height: 93%;
    overflow: hidden;
    overflow-y: auto;
  }

  .headTree {
    width: 100%;
    height: 40px;
    overflow: hidden;
    overflow-y: auto;
    background-color: red;
  }

  /deep/ .van-sticky--fixed .van-tabs__nav {
    background-color: #3767ed !important;
  }

  /deep/ .van-sticky--fixed .van-tabs__line {
    opacity: 0;
  }
}
</style>
